import React, { useEffect, useState } from 'react'
import Header from '../Header'
import Menus from '../MySpace/Menus'
import Profile from '../MySpace/Profile'
import { useNavigate } from "react-router-dom";
import '../MySpace/myspace.css';
import { Col, Container, Image, Row } from 'react-bootstrap';
import Modal from '../Modal';
import { logGuestVisit } from '../../utils/guestVisitLog';
const isMainDomain = () => {
  const hostname = window.location.hostname;
  const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'dastaan.info';
  return hostname === mainDomain || hostname === `www.${mainDomain}` || process.env.REACT_APP_DOMAIN === 'main';
};

function Login() {
  const navigate = useNavigate();
  const user_id = localStorage.getItem('dastaan__user_id') !== undefined ? localStorage.getItem('dastaan__user_id') : 0;
  const isLoggedIn = user_id > 0;
  const [showModal, setShowModal] = useState(user_id <= 0);
  const [dw, setWidth] = useState(0);

  // Read URL params for cross-domain redirect (tagged + not subscribed from dastaan.info)
  const queryParams = new URLSearchParams(window.location.search);
  const initialPhone = queryParams.get('phone') || '';
  const initialStep = queryParams.get('step') || 'phone';

  useEffect(() => {
    const w = window.innerWidth;
    setWidth(w);
    logGuestVisit('login-page');
  }, []);

  // Lock page scroll on the login screen so the background can't drift on mobile.
  // The logged-in branch below is a full page and must stay scrollable.
  useEffect(() => {
    if (isLoggedIn) return;
    const body = document.body;
    const html = document.documentElement;
    const prev = {
      bodyOverflow: body.style.overflow,
      htmlOverflow: html.style.overflow,
      overscroll: body.style.overscrollBehavior,
    };
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';
    return () => {
      body.style.overflow = prev.bodyOverflow;
      html.style.overflow = prev.htmlOverflow;
      body.style.overscrollBehavior = prev.overscroll;
    };
  }, [isLoggedIn]);

  // Only redirect when Login is mounted somewhere other than "/" (e.g. /login).
  // At "/" the logged-in branch below renders in place, so navigating would loop.
  useEffect(() => {
    if (user_id > 0 && window.location.pathname !== '/') {
      navigate("/");
    }
  }, [user_id, navigate]);

  return (
    <>
      <div style={{
        ...(isLoggedIn
          ? { position: 'absolute', minHeight: '100vh', width: '100%' }
          : { position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, overflow: 'hidden' }),
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/${
          window.location.hostname === 'login.dastaan.info'
            ? 'modal-bg-login.jpg'
            : 'modal-bg.png'
        })`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.3)",
          animation: "fadeOverlay 3s infinite alternate",
          zIndex: 1
        }}></div>
        {dw <= 768 && isLoggedIn ? <Header /> : ''}

        {user_id > 0 ? (
          <>
            <Profile width={dw} />
            <Menus width={dw} />
          </>
        ) : (
          <Modal
            show={showModal}
            onClose={() => setShowModal(false)}
            hideCloseButton={true}
            initialPhone={initialPhone}
            initialStep={initialStep}
          />
        )}
      </div>
    </>
  );
}

export default Login
